import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "doctor-skeleton" },
    [
      _c("div", { staticClass: "doctor-skeleton__top d-flex" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-column flex-grow-0 mr-4" },
          [
            _c(VSkeletonLoader, {
              staticClass: "mb-2",
              attrs: { height: "160", width: "120", type: "image" },
            }),
            _vm._v(" "),
            _c(VSkeletonLoader, {
              attrs: { height: "20", width: "120", type: "image" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-column flex-grow-1" },
          [
            _c(VSkeletonLoader, {
              staticClass: "mb-2",
              attrs: { type: "text", width: "84%" },
            }),
            _vm._v(" "),
            _c(VSkeletonLoader, {
              staticClass: "mb-2",
              attrs: { type: "text", width: "56%" },
            }),
            _vm._v(" "),
            _c(VSkeletonLoader, {
              staticClass: "mb-4",
              attrs: { type: "text", width: "76%" },
            }),
            _vm._v(" "),
            _c(VSkeletonLoader, {
              staticClass: "mb-2",
              attrs: { type: "text", width: "93%" },
            }),
            _vm._v(" "),
            _c(VSkeletonLoader, {
              staticClass: "mb-2",
              attrs: { type: "text", width: "93%" },
            }),
            _vm._v(" "),
            _c(VSkeletonLoader, {
              staticClass: "mb-2",
              attrs: { type: "text", width: "62%" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(VSkeletonLoader, {
        staticClass: "mb-6",
        attrs: { height: "48", type: "image" },
      }),
      _vm._v(" "),
      _c(VSkeletonLoader, {
        staticClass: "mb-6",
        attrs: { height: "75", width: "210", type: "image" },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "doctor-skeleton__day d-flex justify-center" },
        [
          _c(VSkeletonLoader, {
            staticClass: "d-flex mb-4",
            attrs: { type: "heading" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "doctor-skeleton__slots" }, [
        _c(
          "div",
          { staticClass: "d-flex" },
          _vm._l(4, function (i) {
            return _c(VSkeletonLoader, {
              key: `skeleton-1-${i}`,
              staticClass: "ma-1 flex-grow-1",
              attrs: { height: "40", type: "image" },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex" },
          _vm._l(4, function (i) {
            return _c(VSkeletonLoader, {
              key: `skeleton-2-${i}`,
              staticClass: "ma-1 flex-grow-1",
              attrs: { height: "40", type: "image" },
            })
          }),
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }